const initialState = {
  loading: false,
  success: false,
  error: null,
};

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_SUBMIT_REQUEST":
      return { ...state, loading: true, error: null, success: false };
    case "API_SUBMIT_SUCCESS":
      return { ...state, loading: false, success: true };
    case "API_SUBMIT_FAILURE":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default apiReducer;
